import { useCallback, useEffect, useRef, useState } from 'react';

type CloseCallback = () => void;

const subscribers = new Set<CloseCallback>();

export const closeAllDropdowns = () => {
  for (const callback of subscribers) {
    callback();
  }
};

export const useDropdownGroup = () => {
  const [isOpen, setIsOpen] = useState(false);

  const callbackRef = useRef<CloseCallback>(() => setIsOpen(false));

  useEffect(() => {
    const callback = callbackRef.current;
    subscribers.add(callback);
    return () => {
      subscribers.delete(callback);
    };
  }, []);

  const open = useCallback(() => {
    for (const cb of subscribers) {
      if (cb !== callbackRef.current) {
        cb();
      }
    }
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  const toggle = useCallback(() => {
    if (isOpen) {
      setIsOpen(false);
    } else {
      open();
    }
  }, [isOpen, open]);

  return { isOpen, open, close, toggle };
};
